import axios from "axios";

export const LOGS_URL = `${process.env.REACT_APP_API_URL}/logs`;

export function getLogs({recordId, recordModel}){
    return axios.get(LOGS_URL, {
        params: {
            model: recordModel,
            recordId: recordId
        }
    })
}